module.exports = __webpack_public_path__ + "static/media/safr.63292481.jpg";